import React from 'react'

const GrowthIndexFormatorSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.538452" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4674_17868)" />
    <path
      d="M36.5885 38.15C39.8456 34.9463 42.9958 31.7961 46.2529 28.5924C45.9859 28.5924 45.8257 28.539 45.6122 28.539C44.4375 28.539 43.2628 28.539 42.0881 28.539C41.4474 28.539 40.8067 28.4322 40.4329 27.7915C39.899 26.8304 40.3261 25.282 41.6076 25.1752C41.8746 25.1752 42.1415 25.1218 42.4619 25.1218C45.0782 25.1218 47.6945 25.1218 50.3108 25.1218C51.9127 25.1218 52.5 25.7091 52.5 27.3644C52.5 30.0875 52.5 32.864 52.5 35.5871C52.5 36.3346 52.1796 36.9753 51.4855 37.2423C50.8448 37.5092 50.1507 37.5092 49.6167 37.0287C49.0828 36.6015 48.976 35.9608 48.976 35.3201C48.976 34.1988 48.976 33.0775 48.976 31.9563C48.976 31.7427 48.976 31.5825 48.976 31.2087C48.6556 31.4757 48.4954 31.5825 48.3353 31.7427C44.918 34.9997 41.5542 38.3636 38.1904 41.674C37.87 41.9944 37.4428 42.2613 37.0157 42.4215C36.3216 42.6351 35.7876 42.2613 35.3071 41.7808C33.5985 40.0722 31.8899 38.3636 30.1812 36.6549C29.8075 36.2812 29.5939 36.2812 29.2735 36.6549C26.4436 39.5382 23.5604 42.3681 20.6771 45.2514C19.8762 46.0523 19.1286 46.1591 18.2743 45.6252C17.4734 45.0912 17.2598 44.1301 17.7938 43.3292C17.954 43.0622 18.1676 42.8487 18.3811 42.6351C21.6916 39.3246 24.9486 36.0676 28.259 32.7572C29.2735 31.7427 30.1812 31.7427 31.1957 32.7572C32.9043 34.4124 34.5596 36.121 36.2682 37.8296C36.375 37.9364 36.5351 38.0966 36.5885 38.15Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17868"
        x1="-1.56654e-06"
        y1="5.5"
        x2="70"
        y2="67.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5A100" />
        <stop offset="1" stopColor="#F14B12" />
      </linearGradient>
    </defs>
  </svg>
)

export default GrowthIndexFormatorSubcategory
